
export class BoxDeliveryDTO{
    projectId: string;
    projectName: string;
    boxId:string;
    receptionDate?: Date;
    sender ?: string;
    labId:string;
    status?: string;
    sampleCount ?: number;
    puid ?:string;
}